import { createStyles } from 'antd-style';
import  colorToken  from '../../utils/colorToken';

export const useMarkdownRendererStyles = createStyles(({ token, css }) => ({
  rendererContainer: css`
    font-family: inherit;
    line-height: 1.6;
    color: var(--color-text-base, ${colorToken.colorTextBase});
    
    * {
      box-sizing: border-box;
    }
  `,
  rendererContent: css`
    position: relative;
  `,
  
  // @uiw/react-md-editor 自定义样式
  markdownRenderer: css`
    .w-md-editor {
      background-color: transparent;
      border: none;
    }
    
    .w-md-editor-content {
      background-color: transparent;
    }
    
    .w-md-editor-preview {
      background-color: transparent;
      padding: ${token.padding}px;
    }
    
    // 标题样式
    h1, h2, h3, h4, h5, h6 {
      color: var(--color-text-base, ${colorToken.colorTextBase});
      font-weight: 600;
      margin: 1em 0 0.5em 0;
    }
    
    h1 {
      font-size: 2em;
      border-bottom: 2px solid var(--color-border, ${colorToken.colorBorder});
      padding-bottom: 0.3em;
    }
    
    h2 {
      font-size: 1.5em;
    }
    
    h3 {
      font-size: 1.25em;
    }
    
    // 列表样式
    ul, ol {
      margin: 1em 0 !important;
      padding-left: 2em !important;
      list-style-position: outside !important;
    }
    
    ul {
      list-style-type: disc !important;
    }
    
    ol {
      list-style-type: decimal !important;
    }
    
    li {
      margin: 0.3em 0 !important;
      display: list-item !important;
      list-style-position: outside !important;
    }
    
    // 嵌套列表样式
    ul ul {
      list-style-type: circle !important;
    }
    
    ul ul ul {
      list-style-type: square !important;
    }
    
    ol ol {
      list-style-type: lower-alpha !important;
    }
    
    ol ol ol {
      list-style-type: lower-roman !important;
    }
    
    // 代码样式
    code {
      background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
      border: 1px solid var(--color-border, ${colorToken.colorBorder});
      border-radius: 3px;
      padding: 2px 4px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9em;
    }
    
    pre {
      background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
      border: 1px solid var(--color-border, ${colorToken.colorBorder});
      border-radius: 6px;
      padding: 1em;
      margin: 1em 0;
      overflow-x: auto;
    }
    
    pre code {
      background-color: transparent;
      border: none;
      padding: 0;
    }
    
    // 表格样式
    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid var(--color-border, ${colorToken.colorBorder});
      margin: 1em 0;
    }
    
    th, td {
      border: 1px solid var(--color-border, ${colorToken.colorBorder});
      padding: 0.5em;
      text-align: left;
    }
    
    th {
      background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
      font-weight: 600;
    }
    
    tr:nth-child(even) {
      background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
    }
    
    // 链接样式
    a {
      color: var(--color-primary, ${colorToken.colorPrimary});
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    // 引用样式
    blockquote {
      border-left: 4px solid var(--color-primary, ${colorToken.colorPrimary});
      margin: 1em 0;
      padding: 0.5em 1em;
      background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
      color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
    }
    
    // 文本样式
    strong {
      font-weight: bold;
    }
    
    em {
      font-style: italic;
    }
    
    del {
      text-decoration: line-through;
    }
  `,
}));

